import { render, staticRenderFns } from "./StepByStep.vue?vue&type=template&id=4a70bdd6&scoped=true&"
import script from "./StepByStep.vue?vue&type=script&lang=js&"
export * from "./StepByStep.vue?vue&type=script&lang=js&"
import style0 from "./StepByStep.vue?vue&type=style&index=0&id=4a70bdd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a70bdd6",
  null
  
)

export default component.exports